import { SCREEN_CONFIG } from '@config/screenConfig';
import { ContactUsPhone } from '~shared/components/Phone/ContactUsPhone';
import { OrderLockedPaymentMethod } from '~shared/segments/OrderLockedScreen';
import { Grid } from '~ui/components/layout/Box';
import { BaseHeaderContent, HeaderScreen } from '../../ScreenLayout';
import { ValidationMessageReason } from '../../Validation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var contentRowGap = "extraLarge";
/**
 * Presents a UI with options to change the method & return to the payment gate.
 * Logic is handled by components & context from `LockedOrderProvider` & `LockedOrderPaymentMethodProvider`.
 */

export var LockedScreenResponsiveLayout = function LockedScreenResponsiveLayout(_ref) {
  var buttons = _ref.buttons,
      order = _ref.order,
      title = _ref.title,
      description = _ref.description,
      children = _ref.children;
  var branch = order === null || order === void 0 ? void 0 : order.branch;
  return /*#__PURE__*/_jsx(HeaderScreen, {
    headerContent: /*#__PURE__*/_jsx(BaseHeaderContent, {
      title: title
    }),
    children: /*#__PURE__*/_jsxs(Grid, {
      padding: "large",
      rowGap: contentRowGap,
      alignContent: "space-evenly",
      gridTemplateColumns: "100%" // fix children overflow
      ,
      margin: {
        vertical: "none",
        horizontal: "auto"
      },
      maxWidth: SCREEN_CONFIG.maxFormWidth,
      children: [/*#__PURE__*/_jsx(ValidationMessageReason, {
        children: description
      }), children && /*#__PURE__*/_jsx(Grid, {
        width: "100%",
        rowGap: "large",
        justifySelf: "center",
        maxWidth: SCREEN_CONFIG.maxFormWidth,
        margin: {
          vertical: "none",
          horizontal: "auto"
        },
        children: /*#__PURE__*/_jsx(OrderLockedPaymentMethod, {})
      }), /*#__PURE__*/_jsx(Grid, {
        rowGap: "medium",
        children: buttons
      }), /*#__PURE__*/_jsx(ContactUsPhone, {
        branch: branch
      })]
    })
  });
};